import React from 'react';
import PropTypes from 'prop-types';

import { Alert } from 'react-bootstrap-5';
import { isBlank } from 'helpers/string_helpers';

export default function TaskFormErrors({ errors }) {
  if (isBlank(errors)) return null;

  let messages = null;

  if (Array.isArray(errors)) {
    messages = errors.map((error, i) => <li key={i}>{error}</li>);
  }

  return (
    <Alert name="errors-alert" variant="danger">
      <h6><strong>Whoops -</strong> There were errors in the form that prevented saving.</h6>
      <ul>{messages}</ul>
    </Alert>
  );
}

TaskFormErrors.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string)
};
